export const apiPath = '/v2/trainings';
const actionType = 'TRAININGS_V2';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
